/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { getOptionalEnvVar } from "@shared/utils/validate-env";

export const HOUSIEN_BACKEND_URL =
  getOptionalEnvVar('REACT_APP_HOUSIEN_BACKEND_URL') ?? "";

export const loggedRoutesList = [
  "/app/workspace",
  "/app/agencies",
  "/app/dashboard",
  "/app/documentation",
  "/app/real-states",
  "/app/real-states/create",
  "/app/real-estate",
  "/app/real-estate/properties",
  "/app/real-estate/settings",
  "/app/register",
  "/app/zustand",
  "/app/crud",
  "/app/loading",
  "/app/test",
  "/app/test-zustand",
];

/**
 * loggedAgencyRoutes function.
 *
 * @param {*} agency_id - Parameter description
 *
 * @returns {*} Return value description
 */
export const loggedAgencyRoutes = (agency_id: string) => {
  return [
    `/app/agencies/${agency_id}`,
    `/app/agencies/${agency_id}/overview`,
    `/app/agencies/${agency_id}/dashboard`,
    `/app/agencies/${agency_id}/dashboards`,
    `/app/agencies/${agency_id}/properties`,
    `/app/agencies/${agency_id}/visits`,
    `/app/agencies/${agency_id}/settings`,
    `/app/agencies/${agency_id}/publications`,
    `/app/agencies/${agency_id}/alerts`,
    `/app/agencies/${agency_id}/crud`,
  ];
};

/**
 * loggedPropertyRoutes function.
 *
 * @param {*} agency_id - Parameter description
 * @param {*} property_id - Parameter description
 *
 * @returns {*} Return value description
 */
export const loggedPropertyRoutes = (
  agency_id: string,
  property_id: string
) => {
  return [
    `/app/agencies/${agency_id}/properties/${property_id}`,
    `/app/agencies/${agency_id}/properties/${property_id}/business`,
    `/app/agencies/${agency_id}/properties/${property_id}/history`,
    `/app/agencies/${agency_id}/properties/${property_id}/similar`,
  ];
};
